// extracted by mini-css-extract-plugin
module.exports = {"svg":"SvgIcon_svg__NTl8Q"};